import BaseApiService from './BaseApiService'

class DocumentService extends BaseApiService {
   constructor() {
      super()
   }

   async getRequiredDocuments(apptTypeId) {
      return await super.execute('get', `document/reqd/${apptTypeId}`)
   }

   async getDocuments(personId) {
      return await super.execute('get', `document/${personId}`)
   }

}

export let documentApi = new DocumentService()
